import * as apiAction from '../actions/sendMail';

export const sendCoupon= (customer) => {
  return apiAction.sendMail(customer).then(response => {
      return response;
  });
};
